export const GenderOptions = [{ value: "Male", label: "Male" }, 
{ value: "Female", label: "Female" }, 
{ value: "Other", label: "Other" }];